export const graphBar16 = "M6 9H3v5h3zm-1 4H4v-3h1zm6-12H8v13h3zm-1 12H9V2h1zm3-8v9h3V5zm2 7.999h-1V6h1zM2 15h14v1H1V1h1z";
